// Title: accessible-menu.ts
//
// Author: Jacco van der Post <vanderpost@redkiwi.nl>
//
// Date: 16-03-2022
//

import AccessibleMenu from "accessible-menu";
import { addClass, removeClass } from "../utils";

/**
 * Main menu functions
 */
export class MainDropDownMenu {
    constructor() {
        MainDropDownMenu.setSubmenuArrow();
        MainDropDownMenu.initMainDropDownMenu();
        MainDropDownMenu.initMobileHamburgerButton();
    }

    /**
     * Set horizontal position of white arrow above fold out menu
     *
     * @private
     *
     * @return void
     */
    private static setSubmenuArrow(): void {
        document
            .querySelectorAll("li.has-submenu > a")
            .forEach((mainMenuItem) =>
                mainMenuItem.addEventListener("click", function (event) {
                    event.preventDefault();

                    const clickedMenuItem = event.target as HTMLElement;
                    const parentElementLi =
                        clickedMenuItem.parentElement.parentElement;
                    const ulElement =
                        parentElementLi.getElementsByTagName("ul")[0];
                    const arrow = ulElement.firstElementChild as HTMLElement;
                    const ulElementLeftPosition =
                        ulElement.getBoundingClientRect().left;
                    const clickedMenuItemPosition =
                        clickedMenuItem.getBoundingClientRect();

                    arrow.style.left =
                        clickedMenuItemPosition.left -
                        ulElementLeftPosition +
                        clickedMenuItemPosition.width / 2 -
                        20 + // correction for &:after dropdown arrow of main item
                        "px";
                })
            );
    }

    /**
     * Init AccesibleMenu script for fold out of mainmenu items
     *
     * @private
     *
     * @return void
     */
    private static initMainDropDownMenu(): void {
        const element = document.querySelector(
            "#main-menu"
        ) as HTMLElement | null;

        if (!element) {
            return;
        }

        new AccessibleMenu.DisclosureMenu({
            menuElement: element,
            menuItemSelector: "li:has(> a)",
            submenuItemSelector: ".has-submenu",
            controllerElement: document.querySelector("#main-menu-toggle"),
            containerElement: document.querySelector("#main-nav"),
            openClass: "dropdown-menu-visible",
            closeClass: "dropdown-menu-invisible",
            optionalKeySupport: true,
        });
    }

    /**
     * Init hamburger icon button for mobile menu
     *
     * @private
     *
     * @return void
     */
    private static initMobileHamburgerButton(): void {
        const element = document.querySelector(
            "#main-menu-toggle"
        ) as HTMLElement | null;
        if (!element) {
            return;
        }

        element.addEventListener("click", function () {
            const expand = document
                .getElementById("main-menu-toggle")
                .getAttribute("aria-expanded");

            // prevent fast doubletouch problems
            if (expand === "true") {
                addClass(
                    document.getElementById("menus-container"),
                    "max1023:block"
                );
            } else {
                removeClass(
                    document.getElementById("menus-container"),
                    "max1023:block"
                );
            }
        });
    }
}
